import RadioList from "../RadioList";
import ICustomFormSettings from "../../ICustomFormSettings";
import VerticalScrollPicker from "../../shared/components/VerticalScrollPicker/VerticalScrollPicker";
import ScrollItem from "../../shared/components/HorizontalScrollPicker/ScrollItem";
import {RadioItem} from "../../../model/items/radio";
import m from "mithril";

export default class RadioListSelectSimple extends RadioList {

    private checkBoxes: RadioItem[] = [];
    private picker: VerticalScrollPicker;

    constructor(settings: ICustomFormSettings) {
        super(settings);

        const grid = settings.form.grid;
        for (let row=0; row < grid.rows; row++) {
            const cell = grid.layout[row][0];
            if (!cell) {
                continue;
            }
            for (const cellItem of cell.cellItems) {
                if (cellItem instanceof RadioItem) {
                    this.checkBoxes.push(cellItem);
                }
            }
        }

        const items = this.checkBoxes.map((checkbox) => {
            return new ScrollItem(
                checkbox.childrenTags.filter(t => t.tag === 'text')[0]?.value || '',
                checkbox.getValue()
            );
        });

        this.picker = new VerticalScrollPicker(
            items,
            this.checkBoxes[0].cell,
            this.checkBoxes[0].getVariable(),
            this.onSelect.bind(this),
            this.onScrollOver.bind(this),
        );


    }

    private onSelect(item: ScrollItem) {
        this.onSetValue(this.checkBoxes[0], item.value);
    }

    private onScrollOver(item: ScrollItem) {
        // nothing
    }

    public view() {
        return this.viewLayout([
            m(this.picker)
        ]);
    }

}